import { createAction, props } from '@ngrx/store';
import { IAssetManagers } from '../models/asset-managers.model';

export const loadGetAssetManagerss = createAction('[GetAssetManagers] Load GetAssetManagerss');

export const loadGetAssetManagerssSuccess = createAction(
  '[GetAssetManagers] Load GetAssetManagerss Success',
  props<{ response: IAssetManagers[] }>()
);

export const loadGetAssetManagerssFailure = createAction(
  '[GetAssetManagers] Load GetAssetManagerss Failure',
  props<{ error: Error | any }>()
);
